<div class="wrapper">
  <button id="scrollToTopButton" (click)="scrollToTop()">TOP</button>
</div>
